import React from 'react';
import { AuthProvider } from './Auth';
import Login from './Login';
import Portfolio from './Portfolio';
import Admin from './Admin';
import AccountsPage from './Accounts';
import NavBar from './NavBar';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ImageGallery from './ImageGallery';
import UploadPage from './Upload';
import ProjectView from './ProjectView';
import ProtectedRoute from './ProtectedRoute';
import { PageLayout } from './utils/util';
import ContactPage from './Contact';
import AboutPage from './About';




const NotFoundPage: React.FC = () => (
    <PageLayout title="404 - Page Not Found">
        <p style={{ color: '#ef4444', fontWeight: 'bold' }}>
            The route you requested does not exist.
        </p>
    </PageLayout>
);

const App: React.FC = () => {
    return (
        <BrowserRouter>
            <AuthProvider>
                <NavBar />
                <div style={{ marginTop: '60px' }}>
                    <Routes>
                        <Route path="/" element={<Portfolio />} />
                        <Route path="/about" element={<AboutPage />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/portfolio/:category" element={<ImageGallery />} />

                        <Route path="/upload" element={<ProtectedRoute><UploadPage /></ProtectedRoute>} />
                        <Route path="/projects" element={<ProtectedRoute><ProjectView /></ProtectedRoute>} />
                        <Route path="/browse" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
                        <Route path="/accounts" element={<ProtectedRoute><AccountsPage /></ProtectedRoute>} />

                        <Route path="*" element={<NotFoundPage />} />
                    </Routes>
                </div>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
